module.exports = __webpack_public_path__ + "static/media/018-server.086da35e.svg";